import config from '../attribute-config.json'

const checkForAttributeMapping = (attributeName, translation) => {
    const attributesMappingConfig = config.attributesMapping
    let name = attributeName

    if(attributesMappingConfig[attributeName.toLowerCase()]) {
        if(translation) {
            name = attributesMappingConfig[attributeName.toLowerCase()][translation.currentLang]
        } else {
            name = attributesMappingConfig[attributeName.toLowerCase()].default
        }
    }

    return name
}

export default checkForAttributeMapping